import {
  CrossClientQueryExecution,
  CrossClientQueryExecutionEvaluationCounts,
  CrossClientQueryExecutionProgress,
  CrossClientQueryPhases,
  CrossClientQueryResultStatuses,
} from '../../models/CrossClient'

const hasRunningEvaluation = (counts?: CrossClientQueryExecutionEvaluationCounts | null): boolean => !!counts && (counts.running > 0 || counts.canceling > 0)

const hasQueuedEvaluation = (counts?: CrossClientQueryExecutionEvaluationCounts | null): boolean => !!counts && (counts.pending > 0 || counts.queued > 0)

export const executionHasRunningEvaluation = (execution?: CrossClientQueryExecution | null): boolean =>
  !!execution && hasRunningEvaluation(execution.evaluationCounts)

export const executionHasQueuedEvaluation = (execution?: CrossClientQueryExecution | null): boolean =>
  !!execution && !hasRunningEvaluation(execution.evaluationCounts) && hasQueuedEvaluation(execution.evaluationCounts)

export const executionIsActive = (execution?: CrossClientQueryExecution | null): boolean =>
  !!execution && (hasRunningEvaluation(execution.evaluationCounts) || hasQueuedEvaluation(execution.evaluationCounts))

export const executionIsRunning = (execution?: CrossClientQueryExecution | null): boolean => executionIsActive(execution)

const countPendingResults = (progress?: CrossClientQueryExecutionProgress | null): number =>
  progress ? (progress.statuses[CrossClientQueryResultStatuses.INITIALIZED] ?? 0) : 0

export const executionNeedsAction = (execution?: CrossClientQueryExecution | null): boolean => {
  if (!execution || executionIsActive(execution)) {
    return false
  }
  const hasUnactionedMatches = !!execution.matches && execution.matches.unactioned > 0
  const hasPendingResults = !!execution.progress && (execution.progress.statuses[CrossClientQueryResultStatuses.INITIALIZED] ?? 0) > 0
  return hasUnactionedMatches || hasPendingResults
}

export const executionIsFinished = (execution?: CrossClientQueryExecution | null): boolean =>
  !!execution && execution.phase === CrossClientQueryPhases.COMPLETED && !executionNeedsAction(execution)

export const countPendingProgressResults = countPendingResults
